import { FastFlowRedirectionReason } from './consts';
export const getFastFlowRedirectionReason = _ref => {
  let {
    shouldChooseShippingMethod,
    hasTermsAndConditions,
    hasCustomField,
    hasTaxZipCodeError,
    hasTaxSubdivisionError,
    hasShippingZipCodeError,
    hasShippingSubdivisionError,
    hasTotalAmountMismatchWithLatestSeen,
    hasViolations,
    hasLineItemPolicies,
    hasMemberOnlyCheckout
  } = _ref;
  const reasons = [];
  if (hasTermsAndConditions) {
    reasons.push(FastFlowRedirectionReason.hasTermsAndConditions);
  }
  if (hasCustomField) {
    reasons.push(FastFlowRedirectionReason.hasCustomField);
  }
  if (hasTaxZipCodeError) {
    reasons.push(FastFlowRedirectionReason.hasTaxZipCodeError);
  }
  if (hasTaxSubdivisionError) {
    reasons.push(FastFlowRedirectionReason.hasTaxSubdivisionError);
  }
  if (hasShippingZipCodeError) {
    reasons.push(FastFlowRedirectionReason.hasShippingZipCodeError);
  }
  if (hasShippingSubdivisionError) {
    reasons.push(FastFlowRedirectionReason.hasShippingSubdivisionError);
  }
  if (hasTotalAmountMismatchWithLatestSeen) {
    reasons.push(FastFlowRedirectionReason.hasTotalAmountMismatchWithLatestSeen);
  }
  if (hasViolations) {
    reasons.push(FastFlowRedirectionReason.hasViolations);
  }
  if (hasLineItemPolicies) {
    reasons.push(FastFlowRedirectionReason.hasLineItemPolicies);
  }
  if (hasMemberOnlyCheckout) {
    reasons.push(FastFlowRedirectionReason.hasMemberOnlyCheckout);
  }
  if (shouldChooseShippingMethod) {
    reasons.push(FastFlowRedirectionReason.shouldChooseShippingMethod);
  }
  if (reasons.length === 0) {
    reasons.push(FastFlowRedirectionReason.unknown);
  }
  return reasons.join();
};
//# sourceMappingURL=bi.util.js.map